import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DashboardSideNavBar from "../side-navbar/DashboardSideNavBar.js";
import { Route, Routes, useNavigate } from "react-router-dom";

import reportIcon from "../../assets/icons/innehav.svg";
import archiveIcon from "../../assets/icons/transaktioner.svg";
import fixedIncomeIcon from "../../assets/icons/ranta.svg";
import equityIcon from "../../assets/icons/aktier.svg";
import alternativeIcon from "../../assets/icons/alternativa.svg";
import feeIcon from "../../assets/icons/avgifter.svg";
import homeIcon from "../../assets/icons/hus.svg";
import downloadIcon from "../../assets/icons/exportera.svg";
import esgIcon from "../../assets/icons/esg.svg";
import marketIcon from "../../assets/icons/marknad.svg";
import "../../StyleCSS/dashboardLanding.css";
import PBIReport from "./PBIReport.js";
import { getPBICredentials } from "../../reducers/PBICredSlice.js";

import { getPBICredentialsForClientid } from "../../reducers/PBICredSlice.js";
import ExportDataPage from "./ExportData.js";
import SessionWatcher from "../../session/SessionWatcher.js";
import { handleExpiredSession } from "../auth/HandleExpiredSession.js";

const ICONS = {
  archive: archiveIcon,
  arkiv: archiveIcon,
  rapport_icon: reportIcon,
  dubbelgraf: reportIcon,
  aktier: equityIcon,
  startsida: homeIcon,
  räntor: fixedIncomeIcon,
  alternativa: alternativeIcon,
  avgifter: feeIcon,
  download_icon: downloadIcon,
  esg: esgIcon,
  marknad: marketIcon,
};

const DEFAULT_ICON = reportIcon; //equity_icon;

const MENU_ITEMS = [
  {
    pathName: "Exportera data",
    route_path: "exportData",
    icon: downloadIcon,
    subItems: false,
  },
];

function dashboardLanding(props) {
  const dispatch = useDispatch();
  //   const pages = useSelector((state) => state.PBICred.pages);
  const [menuItems, setMenuItems] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const navigate = useNavigate();
  const reqStatus = useSelector((state) => state.PBICred.status);
  const [isError, setIsError] = useState(false);
  const [noReport, setNoReport] = useState(false);
  const [tokenExpired, setTokenExpired] = useState(false);

  const [showButton, setShowButton] = useState(false); // Controls modal visibility
  const [clients, setClients] = useState([]); // Stores the clients array
  const [selectedClient, setSelectedClient] = useState(""); // Tracks the selected client

  useEffect(() => {
    loadReport();
  }, [tokenExpired]);

  function loadReport() {
    setLoaded(false);
    // get PBI credentials which includes pages
    dispatch(getPBICredentials())
      .then((resp) => {
        if (resp.meta.requestStatus === "rejected") {
          setIsError(true);
          return;
        }
        if (resp.payload.statusText == "More-then-one") {
          const allClients =
            resp?.payload?.clientRespAll?.resp?.map((item) => ({
              clientId: item.clientId,
              name: item.name,
            })) || [];

          // Add a button to confirm selection
          setClients(allClients || []); // Populate the dropdown data
          setShowButton(true);
        }
        if (
          resp.meta.requestStatus === "fulfilled" &&
          Array.isArray(resp.payload.reportPages)
        ) {
          // if successful, create menu items from pages including myaccount item.
          let items = resp.payload.reportPages
            .map((p) => {
              return {
                pathName: p.displayName,
                route_path: `rapport/${p.name}`,
                icon: ICONS[p.icon] ? ICONS[p.icon] : DEFAULT_ICON, // set defualt icon here
                subItems: false,
              };
            })
            .concat([...MENU_ITEMS]);

          // set menu items
          setMenuItems(items);

          //navigate to the first page
          if (items.length) {
            setNoReport(false);
            navigate("/dashboard/" + items[0].route_path);
          } else {
            setNoReport(true);
          }
        }
      })
      .finally(() => {
        // when everything is loaded we can show the menu and
        setLoaded(true);
        setTokenExpired(false);
      });
  }

  function loadSpecificReport(clientId) {
    dispatch(getPBICredentialsForClientid({ clientID: selectedClient }))
      .then((resp) => {
        if (resp.payload.statusText == "More-then-one") {
          const allClients =
            resp?.payload?.clientRespAll?.resp?.map((item) => ({
              clientId: item.clientId,
              name: item.name,
            })) || [];

          setClients(allClients || []); // Populate the dropdown data
          setShowButton(true);
        }
        if (
          resp.meta.requestStatus === "fulfilled" &&
          Array.isArray(resp.payload.reportPages)
        ) {
          // if successful, create menu items from pages including myaccount item.
          let items = resp.payload.reportPages
            .map((p) => {
              return {
                pathName: p.displayName,
                route_path: `rapport/${p.name}`,
                icon: ICONS[p.icon] ? ICONS[p.icon] : DEFAULT_ICON, // set defualt icon here
                subItems: false,
              };
            })
            .concat([...MENU_ITEMS]);

          // set menu items
          setMenuItems(items);

          //navigate to the first page
          if (items.length) {
            //Reload report
            setNoReport(true);
            setNoReport(false);
            navigate("/dashboard/" + items[0].route_path);
          } else {
            setNoReport(true);
          }
        }
      })
      .finally(() => {
        // when everything is loaded we can show the menu and
        setLoaded(true);
        setTokenExpired(false);
      });
  }

  useEffect(() => {
    if (reqStatus === "rejected") {
      setIsError(true);
    } else {
      setIsError(false);
    }
  }, [reqStatus]);

  return (
    <div className="dashboardLanding">
      <SessionWatcher />
      {loaded ? (
        <DashboardSideNavBar
          routes={menuItems}
          showPortfolioSelector={showButton}
          portfolioClients={clients}
          selectedPortfolio={selectedClient}
          onPortfolioChange={setSelectedClient}
          onLoadPortfolio={loadSpecificReport}
        />
      ) : null}
      {noReport ? (
        <h2 className="NoReportError">Du har för tillfället ingen rapport</h2>
      ) : isError ? (
        <h2 className="NoReportError">
          {" "}
          Kunde inte hämta rapport, kontakta din rådgivare eller försök igen
          senare{" "}
        </h2>
      ) : (
        <div className="dashboardHomeContainer">
          <Routes>
            <Route
              path="/rapport/:pageName/*"
              element={
                <PBIReport
                  reloadReport={loadReport}
                  tokenExpired={tokenExpired}
                  setTokenExpired={setTokenExpired}
                />
              }
              key={window.location.pathname + "/rapport"}
            />
            <Route
              path="/exportData/*"
              element={<ExportDataPage selectedClient={selectedClient} />}
              key={window.location.pathname + "/exportData"}
            />

            {/* <Route
                            path="/arkiv/*"
                            element={<Archive/>}
                            key={window.location.pathname + "/arkiv"}
                        /> */}
          </Routes>
        </div>
      )}
    </div>
  );
}

// function MyAccount(props) {
//   return <div>kontosida här</div>;
// }

// function Archive(props) {
//   return <div>arkivsida här</div>;
// }

export default dashboardLanding;
